<template>
<div class="row" style="padding: 12px;">
<div class="col-md-12 p-0">
<div class="card table-card">
<div class="card-block" style="padding: 0;">
<div class="table-responsive" style="overflow-x: inherit;">
    <table class="table table-hover mb-0" style="margin-bottom: 2rem;">
        <thead>
            <tr>
                <th style="padding: 4px 0px 4px 20px;">Používateľ (e-mail)</th>
                <th style="padding: 4px 0px 4px 20px;">Počet ponúk</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="user in filteredItems" :key="user.id">
                <td style="padding: 4px 0px 4px 20px;">
                    <div class="d-inline-block align-middle">
                        <div class="d-inline-block">
                            <h6> 
                                {{ user[0]}}
                            </h6>
                        </div>
                    </div>
                </td>
                <td style="padding: 4px 0px 4px 20px;">
                    <div class="d-inline-block align-middle">
                        <div class="d-inline-block">
                            <h6> 
                                {{ user[1]}}
                            </h6>
                        </div>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</div>
</div>
</div>
</div>
</div>
</template>
<script>
    export default {
        props: ['data'],
        data() {
            return {
              emails: null,
              offers: null,
            }
        },
        created() {
          this.emails = this.data[0]
          this.offers = this.data[1]
        },   
        methods: {
           
        },
        computed: {
        filteredItems() {
            var items = []
            var index = 0;
            this.emails.forEach(element => {
              items.push([element, this.offers[index]])
              index++;
            });
            return items
        }
    }
}
</script>

<style lang="scss">
.create_klient{
    width: 230px;
    height: 55px;
    @media only screen and (max-width: 600px) {    
        margin-top: 25px;
        width: 280px;
        float: left;
    }
    background: #2ED8B6;
    border-radius: 4px;
    font-family: Roboto;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    color: #FFFFFF;
    cursor: pointer;
    transition: .5s all;
    float: right;
    &:hover{
        background: #23caa9;
        color: #FFFFFF;
    }
    &.disabled{
        cursor: no-drop;
        pointer-events: none;
        opacity: 0.3;
    }
}
</style>
<style lang="scss" scoped>
td,th{
    white-space: normal !important;
}
</style>